module.exports = __webpack_public_path__ + "img/allocate.8bbdb107.png";